module.exports = __webpack_public_path__ + "img/tag3.3bb5448b.png";